import type { UseOutgoingCallsUploadPopupReturn } from '../../../hooks/features/useOutgoingCallsUploadPopup/useOutgoingCallsUploadPopup';
import type { ErrorState } from './types';
import {
  isBeforeMinimumCampaignStartDate,
  isCampaignEndAfterStart,
} from '../../../utils/campaignDateTimeRestrictions';

const ACCEPTED_FILE_REGEX = /\.xlsx$/i;
const FILE_VALIDATION_MESSAGE = 'Поддерживается только формат .xlsx';

export const validateOutgoingCallsUpload = (
  reportData: UseOutgoingCallsUploadPopupReturn,
): ErrorState => {
  const newErrors: ErrorState = {};

  if (!reportData.taskType) {
    newErrors.taskType = {
      validateStatus: 'error',
      help: 'Выберите сценарий',
    };
  }

  if (
    reportData.taskType &&
    (reportData.scenarioGroup === 'dispensarization' ||
      reportData.scenarioGroup === 'form') &&
    !reportData.name.trim()
  ) {
    newErrors.name = {
      validateStatus: 'error',
      help: 'Укажите название кампании',
    };
  }

  if (
    reportData.taskType &&
    (reportData.scenarioGroup === 'dispensarization' ||
      reportData.scenarioGroup === 'form') &&
    !reportData.fromDate
  ) {
    newErrors.fromDate = {
      validateStatus: 'error',
      help: 'Укажите дату/время начала',
    };
  }

  if (
    reportData.taskType &&
    reportData.scenarioGroup === 'dispensarization' &&
    !reportData.toDate
  ) {
    newErrors.toDate = {
      validateStatus: 'error',
      help: 'Укажите дату/время окончания',
    };
  }

  if (
    reportData.taskType &&
    (reportData.scenarioGroup === 'dispensarization' ||
      reportData.scenarioGroup === 'form') &&
    reportData.fromDate &&
    isBeforeMinimumCampaignStartDate(reportData.fromDate)
  ) {
    newErrors.fromDate = {
      validateStatus: 'error',
      help: 'Дата начала не может быть раньше завтрашнего дня',
    };
  }

  if (
    reportData.taskType &&
    reportData.scenarioGroup === 'dispensarization' &&
    reportData.toDate &&
    !isCampaignEndAfterStart({
      startDate: reportData.fromDate,
      startTime: reportData.fromTime,
      endDate: reportData.toDate,
      endTime: reportData.toTime,
    })
  ) {
    newErrors.toDate = {
      validateStatus: 'error',
      help: 'Дата/время окончания должны быть позже даты/времени начала',
    };
  }

  if (!reportData.fileList || !reportData.fileList.length) {
    newErrors.fileList = {
      validateStatus: 'error',
      help: 'Загрузите файл',
    };
  } else if (
    reportData.fileList[0].name &&
    !ACCEPTED_FILE_REGEX.test(reportData.fileList[0].name)
  ) {
    newErrors.fileList = {
      validateStatus: 'error',
      help: FILE_VALIDATION_MESSAGE,
    };
  }

  return newErrors;
};
